import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import video from "../images/v1.mp4";

const Services = () => {
  const navigate = useNavigate();

  const services = [
    { name: "Android Zero Touch Enrollment", path: "/services/android-zero-touch-enrollment" },
    { name: "Android Management", path: "/services/android-management" },
    { name: "Cloud Computing", path: "/services/cloud-computing" },
    { name: "Cloud Management Service", path: "/services/cloud-management-service" },
    { name: "Cyber Security", path: "services/cyber-security" },
    { name: "IOS Management", path: "/services/ios-management" },
    { name: "Mobile Management", path: "/services/mobile-management" },
    { name: "IT Management", path: "/services/it-management" },
    { name: "IT Support", path: "/services/it-support" },
    { name: "Software Development", path: "/services/software-development" },
    { name: "Digital Marketing", path: "/services/digital-marketing" },
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.5,
        ease: "easeOut",
      },
    }),
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", color: "#fff" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          width: "100%",
          minHeight: "60vh",
          background: "linear-gradient(90deg, #020024 0%, #090979 35%, #0b687b 100%)",
        }}
      >
        {/* Left Side - Services List */}
        <div
          style={{
            flex: "1 1 50%",
            padding: "40px 20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <motion.h2
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{ fontSize: "2rem", marginBottom: "20px" }}
          >
            Our Services
          </motion.h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)", // Two columns
              gap: "15px",
            }}
          >
            {services.map((service, index) => (
              <motion.div
                key={index}
                custom={index}
                initial="hidden"
                animate="visible"
                variants={cardVariants}
                whileHover={{
                  scale: 1.05,
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                }}
                style={{
                  background: "rgba(255, 255, 255, 0.1)",
                  padding: "15px",
                  borderRadius: "8px",
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "transform 0.3s ease, background 0.3s ease",
                  textAlign: "center",
                }}
                onClick={() => navigate(service.path)}
              >
                {service.name}
              </motion.div>
            ))}
          </div>
        </div>

        {/* Right Side - Video */}
        <div style={{ flex: "1 1 50%", position: "relative", minHeight: "60vh" }}>
          <motion.video
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: "100%",
              height: "100%",
              //   objectFit: "cover",
              borderRadius: "0px",
            }}
          >
            <source src={video} type="video/mp4" />
          </motion.video>
        </div>
      </div>
    </div>
  );
};

export default Services;
